module.exports = __webpack_public_path__ + "img/ylBj2.4012d58c.png";